$(function() {  
	var s2sInput = document.getElementById("s2s");
	var s2sDealInput = document.getElementById("s2s-deal-id");
	var s2sUserInput = document.getElementById("s2s-user-id");

  	var s2s = readCookie("s2s");
  	var s2sDealId = readCookie("s2s-deal-id");
  	var s2sUserId = readCookie("s2s-user-id");

  	if (s2s != null) {
  		s2sInput.value = s2s;
  	}
  	if (s2sDealId != null) {
  		s2sDealInput.value = s2sDealId;
  	}
  	if (s2sUserId != null) {
  		s2sUserInput.value = s2sUserId;
  	}
});

function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}